/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ReportIssueDialog.vue?vue&type=template&id=1dae1b5c"
import script from "./ReportIssueDialog.vue?vue&type=script&lang=js"
export * from "./ReportIssueDialog.vue?vue&type=script&lang=js"
import style0 from "./ReportIssueDialog.vue?vue&type=style&index=0&id=1dae1b5c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dae1b5c')) {
      api.createRecord('1dae1b5c', component.options)
    } else {
      api.reload('1dae1b5c', component.options)
    }
    module.hot.accept("./ReportIssueDialog.vue?vue&type=template&id=1dae1b5c", function () {
      api.rerender('1dae1b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admins/ReportIssueDialog.vue"
export default component.exports